import { render, staticRenderFns } from "./companyData.vue?vue&type=template&id=3fa022e8&scoped=true&"
import script from "./companyData.vue?vue&type=script&lang=js&"
export * from "./companyData.vue?vue&type=script&lang=js&"
import style0 from "./companyData.vue?vue&type=style&index=0&id=3fa022e8&prod&lang=less&scoped=true&"
import style1 from "./companyData.vue?vue&type=style&index=1&id=3fa022e8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa022e8",
  null
  
)

export default component.exports